var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopiar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3337 0.832031H2.33366C1.41699 0.832031 0.666992 1.58203 0.666992 2.4987V14.1654H2.33366V2.4987H12.3337V0.832031ZM14.8337 4.16536H5.66699C4.75033 4.16536 4.00033 4.91536 4.00033 5.83203V17.4987C4.00033 18.4154 4.75033 19.1654 5.66699 19.1654H14.8337C15.7503 19.1654 16.5003 18.4154 16.5003 17.4987V5.83203C16.5003 4.91536 15.7503 4.16536 14.8337 4.16536ZM14.8337 17.4987H5.66699V5.83203H14.8337V17.4987Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiar);
export default __webpack_public_path__ + "static/media/copiar.77dfad988cfbf6505c44c9d87fe49b06.svg";
export { ForwardRef as ReactComponent };